import { render, staticRenderFns } from "./EstimationStatusBadgeComponent.vue?vue&type=template&id=07075284"
import script from "./EstimationStatusBadgeComponent.vue?vue&type=script&lang=js"
export * from "./EstimationStatusBadgeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports